import { useTrans } from "@/translations";

import { useMemo } from "react";

import type { BuildingColumnKey, BuildingListColumn, SortDir } from "../types";

type Props = {
  column: BuildingListColumn;
  sortKey: BuildingColumnKey;
  sortDir: SortDir;
  onSort: (key: BuildingColumnKey) => void;
};

export const ColumnHeaderView: React.FC<Props> = ({
  column,
  sortKey,
  sortDir,
  onSort,
}) => {
  const { t } = useTrans();

  const isActive = useMemo(() => sortKey === column.key, [sortKey, column]);

  return (
    <th
      onClick={() => onSort(column.key)}
      className={`text-grey6 cursor-pointer px-[12px] pt-0 pb-[11.5px] text-[11.5px] font-semibold tracking-[0.04em] whitespace-nowrap uppercase select-none ${
        column.align === "right" ? "text-right" : "text-left"
      }`}
    >
      {t(column.label)}
      {isActive && (
        <span className="ml-[4px] text-[9px]">
          {sortDir === "asc" ? "▲" : "▼"}
        </span>
      )}
    </th>
  );
};
